<template>
     <div class="block11">
          <!-- 返回 -->
          <div class="return">
              <router-link to="/"><span class="arrow"></span>返回首页</router-link>
          </div>
          <!-- 返回 -->
          <!-- 内容 -->
          
          
          <div class="container">
            <h2 class="title1">开关</h2>
            <div class="container-content">
              <img src="./img/img1.jpg" alt="" width="100%">

              <p>
                <strong>1.超车灯开关:</strong><br>闪烁远光灯。
              </p>
              <p>
                <strong>2.双闪开关:</strong><br>闪烁所有转向灯。
              </p>
              <p>
                <strong>3.发动机停止开关:</strong><br>
                正常情况下应该停留在<img src="../img/yunzhuan.png" class="icon_middle">运转位置。<br>
                <img src="../img/san.png">紧急情况下，将开关拨到<img src="../img/zhinankaiguan.png" class="icon_middle">关闭位置停止发动机。
              </p>
              <p>
                <strong>4.前照灯开关:</strong><br>
                <img src="../img/qzd.png" class="icon_middle"> 前照灯、尾灯、位置灯、牌照灯亮起。<br>
                <img src="../img/wzd.png" class="icon_middle"> 位置灯、尾灯、牌照灯亮起。<br>
                 <strong> · </strong>前照灯、尾灯、位置灯、牌照灯熄灭。
              </p>
              
              <p>
                 <strong>5.转向信号开关:</strong><br>
                  <img src="../img/san.png">按下开关可关闭转向灯。
              </p>
              <p>
                <strong>6.前照灯调光开关</strong><br>
                <img src="../img/ygd.png" class="icon_middle"/> 远光<br>
                <img src="../img/jgd.png" class="icon_middle" /> 近光
              </p>
              <p>
                <strong>7.点火开关</strong><br>
                开启/关闭电气系统、锁定转向。<br>
                处于<img class="icon_middle" src="../img/zhinankaiguan.png">（关闭）或锁定位置时可以拔下钥匙。
              </p>
              <p id="tiaozhuan" >转向锁</p>
              <img src="./img/img2.jpg" width="100%">
              <p>停车时锁定方向把以防被盗。<br>同时推荐U型轮锁或相似的装置。</p>
              <p class="text_square" >锁定</p>
              <ul class="numberspace">
                <li>
                  <em>1</em>将方向把最大程度地朝左或右转动。
                </li>
                <li>
                  <em>2</em>按下钥匙，然后将点火开关转至锁定位置。
                    <ul class="triangle">
                      <li>
                        如果很难锁上可以轻轻摇晃车把。
                      </li>
                    </ul>
                </li>
                <li>
                  <em>3</em>取下钥匙。
                </li>
              </ul>
              <p class="text_square">解锁</p>
              <p>插入钥匙，然后将点火开关转至 <img class="icon_middle" src="../img/zhinankaiguan.png" alt=""/> （关）位置。</p>
            </div>
            <div class="foot-btn">
              <div class="prev">
                <router-link to="/block10">上一页</router-link>
              </div>
              <div class="next">
                <router-link to="/block12">下一页</router-link>
              </div>
          </div>
          </div>
        </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>